import { render, staticRenderFns } from "./horarioAtencion.vue?vue&type=template&id=626c1fa1&scoped=true&"
import script from "./horarioAtencion.vue?vue&type=script&lang=js&"
export * from "./horarioAtencion.vue?vue&type=script&lang=js&"
import style0 from "./horarioAtencion.vue?vue&type=style&index=0&id=626c1fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c1fa1",
  null
  
)

export default component.exports